<script lang="ts">
// TEMPORARY SHIM — the component now lives in @lifk/ui-core. This re-export keeps
// existing `@/components/ui/UIBrow.vue` imports working during the migration.
// Remove this file once fieldkit-resdesign-2026 has merged and call sites import
// from @lifk/ui-core directly.
// Dev note: editing the @lifk/ui-core source does NOT hot-update already-mounted
// instances through this .vue shim (Vite registers a duplicate HMR record) — reload.
import shimmed from '@lifk/ui-core/UIBrow.vue'
export default shimmed
</script>
